// extracted by mini-css-extract-plugin
export default {"container":"ScreenTitle_container__kqrPk","backButton":"ScreenTitle_backButton__ORpfq"};